/**
 * Created by Ram on 12/05/2017.
 */

import React, { Component } from "react";
import MatrixAnalysis from "../presentation/MatrixAnalysis";
import dynamicSort from "../../logic/DynamicSort";
import {ScenarioTypes} from "../../enum/ScenarioEnum"

let getTriggersFromDbResult, getTriggersFromDevicesLogsResult;
let checkInDataCache = null;

class MatrixAnalysisWidget extends Component {
    constructor(props) {
        super(props);

        this.isUnmounted = false;

        this.state = {
            testInstanceId: this.props.pageParameters[0],
            testInstance: null,
            devices: [],
            zones: [],
            triggers: [],
            dwellEvents: [],
            displayAsIcons: false,
            showSinglePercentage: false,
            displayTableByPlatform: "Both",
            sortDevices: "name",
            sortDevicesAsc: true,
            sortZones: "firstTriggerTime",
            sortZonesAsc: true,
            showPanels: false,
            readTriggersDataFromLogs: false,
            isLoading: true,
            tttMetric: "eventTime"
        };
    }

    componentDidMount() {
        this.getTestInstance();
    }

    componentWillUnmount() {
        this.isUnmounted = true;
    }

    getTestInstance = () => {
        fetch(
            "/service/getSingleTestInstanceDetails?testInstanceId=" +
            this.state.testInstanceId,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                credentials: "same-origin"
            }
        ).then(response => {
            if (response.status === 200) {
                response.json().then(testInstance => {
                    let readTriggersDataFromLogs = false
                    if( testInstance && testInstance.scenario && testInstance.scenario.type == ScenarioTypes.STARTUP )
                        readTriggersDataFromLogs = true;
                    this.setState({ testInstance, readTriggersDataFromLogs }, this.getDevices);
                });
            }
        });
    };

    getDevices = () => {
        const deviceIds = this.state.testInstance.devices.map(({ deviceId }) => deviceId);

        this.setState({ isLoading: true }, () => {
            fetch("/service/getClusterDevices?devices=" + deviceIds, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                credentials: "same-origin"
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(results => {

                        const devices = results.map(device => {
                            device.isShowing = true;
                            device.isSelected = false;
                            return device
                        });

                        devices.sort(
                            dynamicSort(
                                this.state.sortDevices,
                                this.state.sortDevicesAsc ? 1 : -1
                            )
                        );

                        if (!this.isUnmounted) {
                            this.setState({ devices, isLoading: false }, this.getTriggers);
                        }
                    });
                }
            });
        });
    };

    getTriggers = () => this.state.readTriggersDataFromLogs ? this.getTriggersFromDevicesLogs() : this.getTriggersFromDb()

    fetchCheckInData = () => {
        const testInstanceId = this.state.testInstance._id;
        
        if (checkInDataCache && checkInDataCache.testInstanceId === testInstanceId) {
            return Promise.resolve(checkInDataCache.results);
        }
        
        return fetch(`/service/triggerEvents/${testInstanceId}&checkIn`, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            credentials: "same-origin"
        })
        .then(response => response.json())
        .then(results => {
            checkInDataCache = { testInstanceId, results };
            return results;
        });
    };

    getDwellEvents = () => this.state.readTriggersDataFromLogs ? this.getDwellEventsFromDevicesLogs() : this.getDwellEventsFromDb()

    getDwellEventsFromDevicesLogs = () => {
        const { testInstance } = this.state
        const dwellEvents = [];

        testInstance.devices.forEach(device => {
            if (device.log && device.log.dwellTriggers) {
                device.log.dwellTriggers.forEach(dwell => {
                    dwellEvents.push({
                        deviceId: device.identifier || device.deviceId,
                        zoneId: dwell.zoneId,
                        zoneName: dwell.zoneName,
                        time: dwell.time,
                        dwellTime: dwell.dwellTime,
                        threshold: dwell.threshold,
                        locationUpdate: dwell.locationUpdate
                    });
                });
            }
        });

        this.setState({ dwellEvents });
    };

    getDwellEventsFromDb = () => {
        this.fetchCheckInData().then(results => {
            const dwellEvents = [];
            
            results.forEach(trigger => {
                if (trigger.dwellEvents || trigger.dwellReceived === 1) {
                    dwellEvents.push({
                        deviceId: trigger.identifier,
                        zoneId: trigger.zoneId,
                        zoneName: trigger.zoneName,
                        receivedAt: trigger.receivedAt?.value,
                        eventTime: trigger.triggerEvents?.eventTime,
                        dwellTime: trigger.dwellEvents?.dwellTime || trigger.dwellEvent?.dwellTime,
                        threshold: trigger.dwellEvents?.threshold || trigger.dwellEvent?.threshold,
                        latitude: trigger.triggerEvents?.latitude,
                        longitude: trigger.triggerEvents?.longitude
                    });
                }
            });
            
            console.log('Dwell events found:', dwellEvents);
            this.setState({ dwellEvents });
        }).catch(error => console.error(`Error getting dwell events from DB: ${error}`));
    };

    getTriggersFromDevicesLogs = () => {
        const { testInstance } = this.state
        const triggers = [];

        testInstance.devices.forEach(device => {
            if (device.log && device.log.zones && device.log.triggers) {
                device.log.triggers.forEach(trigger => {
                    triggers.push({
                        deviceId: device.identifier || device.deviceId,
                        zoneId: trigger.zoneId,
                        timeSinceStart: new Date(trigger.time) - new Date(device.log.sessionStart)
                    });
                });
            }
        });

        if (testInstance.scenario && testInstance.scenario.zones && testInstance.scenario.zones.length) {
            const zones = testInstance.scenario.zones.map(zone => ({
                _id: zone.zoneId,
                name: zone.zoneName,
                isShowing: true,
            }));
            this.setState({ triggers, zones }, () => {
                this.getScenarioZones();
                this.getDwellEventsFromDevicesLogs();
            });
        } else {
            this.setState({ triggers }, () => {
                this.getScenarioZones();
                this.getDwellEventsFromDevicesLogs();
            });
        }
    };

    getTriggersFromDb = (triggerType = 'checkIn') => {
        const testInstanceId = this.state.testInstance._id
        let handleResults = results => {
            getTriggersFromDbResult = {testInstanceId, results}
            const { scenario } = this.state.testInstance;
            const triggers = results.map(trigger => ({
                deviceId: trigger.identifier,
                zoneId: trigger.zoneId,
                zoneName: trigger.zoneName,
                receivedAt: trigger.receivedAt.value,
                eventTime: trigger.triggerEvents.eventTime,
                shouldExit: trigger.zoneName.endsWith("CO"),
                didExit: trigger.exitTriggers&&trigger.exitTriggers.length&&true
            }));

            if (scenario && scenario.zones) {
                const zones = scenario.zones.map(zone => ({
                    _id: zone.zoneId,
                    name: zone.zoneName,
                    isShowing: true,
                }));
                this.setState({ triggers, zones }, () => {
                    this.getDwellEventsFromDb();
                });
            } else {
                this.setState({ triggers }, () => {
                    this.getScenarioZones();
                    this.getDwellEventsFromDb();
                });
            }
        }
        if( getTriggersFromDbResult && getTriggersFromDbResult.testInstanceId == testInstanceId ) {
            handleResults(getTriggersFromDbResult.results)
        } else if (triggerType === 'checkIn') {
            this.fetchCheckInData().then(handleResults).catch(error => console.error(`Error getting triggers from DB: ${error}`));
        } else {
            fetch(`/service/triggerEvents/${testInstanceId}&${triggerType}`,
                {
                    method: 'GET',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    credentials: "same-origin"
                }
            ).then(response => {
                response.json().then(handleResults)
            }).catch(error => console.error(`Error getting triggers from DB: ${error}`))
        }
    };

    getScenarioZones = () => {
        const { scenarioId } = this.state.testInstance
        fetch(`/service/getScenario?scenarioId=${scenarioId}`,
            {
                method: 'GET',
                'Content-Type': 'application/json',
                Accept: 'application/json',
                credentials: 'same-origin'
            }
        ).then(response => {
            response.json().then(results => {
                const zones = results.zones.map(zone => ({
                    _id: zone.zoneId,
                    name: zone.zoneName,
                    isShowing: true,
                }))

                this.setState({ zones })
            })
        }).catch(error => console.error(`Error retrieving scenario zones ${error}`))
    }

    updateTableByPlatform = e => {
        const value = e.target.value;
        this.setState({
            displayTableByPlatform: value
        });
    };

    toggleDisplayAsIcons = () => {
        this.setState(prevState => ({ displayAsIcons: !prevState.displayAsIcons }));
    };

    toggleShowSinglePercentage = e => {
        let value = e.target.value === "true";
        this.setState({ showSinglePercentage: value });
    };

    toggleReadTriggersDataFromLogs = () => {
        this.setState(state => ({ readTriggersDataFromLogs: !state.readTriggersDataFromLogs }),
            () => {
                if (this.state.readTriggersDataFromLogs) {
                    this.getTriggersFromDevicesLogs()
                } else {
                    this.getTriggersFromDb()
                }
            }
        )
    }

    /* Showing and selecting devices */

    toggleSelectDevice = deviceId => {
        this.setState(prevState => {
            const { devices, zones } = { ...prevState };
            const device = devices.find(device => device._id === deviceId);
            const deviceNewSelectedState = !device.isSelected && device.isShowing;
            devices.forEach(device => (device.isSelected = false));
            zones.forEach(zone => (zone.isSelected = false));
            device.isSelected = deviceNewSelectedState;
            return { devices, zones };
        });
    };

    toggleShowDevice = deviceId => {
        this.setState(prevState => {
            const { devices } = { ...prevState };
            const device = devices.find(device => device._id === deviceId);
            device.isShowing = !device.isShowing;
            device.isSelected = false;
            return { devices };
        });
    };

    toggleShowAllDevices = () => {
        this.setState(prevState => {
            const { devices } = { ...prevState };
            const showAll = !devices.every(({ isShowing }) => isShowing);
            devices.forEach(device => {
                device.isShowing = showAll;
                device.isSelected = device.isSelected && showAll;
            });
            return { devices };
        });
    };

    updateDevicesSortState = sort => {
        this.setState(prevState => {
            const { devices } = { ...prevState };
            const sortDevices = sort;
            const sortDevicesAsc =
                prevState.sortDevices === sort
                    ? !prevState.sortDevicesAsc
                    : prevState.sortDevicesAsc;
            devices.sort(dynamicSort(sortDevices, sortDevicesAsc ? 1 : -1));
            return {
                devices,
                sortDevices,
                sortDevicesAsc
            };
        });
    };

    /* Showing and selecting zones */

    toggleSelectZone = zoneId => {
        this.setState(prevState => {
            const { devices, zones } = { ...prevState };
            const zone = zones.find(zone => zone._id === zoneId);
            const zoneNewSelectedState = !zone.isSelected && zone.isShowing;
            devices.forEach(device => (device.isSelected = false));
            zones.forEach(zone => (zone.isSelected = false));
            zone.isSelected = zoneNewSelectedState;
            return { devices, zones };
        });
    };

    toggleShowZone = zoneId => {
        this.setState(prevState => {
            const { zones } = { ...prevState };
            const zone = zones.find(zone => zone._id === zoneId);
            zone.isShowing = !zone.isShowing;
            zone.isSelected = false;
            return { zones };
        });
    };

    toggleShowAllZones = () => {
        this.setState(prevState => {
            const { zones } = { ...prevState };
            const showAll = !zones.every(({ isShowing }) => isShowing);
            zones.forEach(zone => {
                zone.isShowing = showAll;
                zone.isSelected = zone.isSelected && showAll;
            });
            return { zones };
        });
    };

    updateZonesSortState = sort => {
        this.setState(prevState => {
            const { zones } = { ...prevState };
            const sortZones = sort;
            const sortZonesAsc =
                prevState.sortZones === sort
                    ? !prevState.sortZonesAsc
                    : prevState.sortZonesAsc;
            zones.sort(dynamicSort(sortZones, sortZonesAsc ? 1 : -1));
            return {
                zones,
                sortZones,
                sortZonesAsc
            };
        });
    };

    toggleShowPanels = () => {
        this.setState(prevState => ({
            showPanels: !prevState.showPanels
        }));
    };

    setTTTMetric = (event) => {
        let newValue = event.target.value;
        this.setState(() => ({tttMetric: newValue}) );
    };

    render() {
        return (
            <MatrixAnalysis
                navigator={this.props.navigator}
                loadData={this.state}
                updateTableByPlatform={this.updateTableByPlatform}
                toggleDisplayAsIcons={this.toggleDisplayAsIcons}
                toggleShowSinglePercentage={this.toggleShowSinglePercentage}
                toggleSelectDevice={this.toggleSelectDevice}
                toggleSelectZone={this.toggleSelectZone}
                toggleShowZone={this.toggleShowZone}
                toggleShowAllZones={this.toggleShowAllZones}
                toggleShowDevice={this.toggleShowDevice}
                toggleShowAllDevices={this.toggleShowAllDevices}
                updateDevicesSortState={this.updateDevicesSortState}
                updateZonesSortState={this.updateZonesSortState}
                toggleShowPanels={this.toggleShowPanels}
                toggleReadTriggersDataFromLogs={this.toggleReadTriggersDataFromLogs}
                setTTTMetric={this.setTTTMetric}
            />
        ); //return
    } //render
} //MatrixAnalysisWidget

export default MatrixAnalysisWidget;
